module.exports = __webpack_public_path__ + "static/motor-cortex-2d5b5b5c0f62b7cf91b1cf09ce7a5e40.jpg";